import { Outlet, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuthStore } from '../stores/auth.store';
import { NeptuneScene } from '../components/neptune/NeptuneScene';

export default function AuthLayout() {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to="/tracking" replace />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: { xs: 'center', md: 'flex-end' },
        position: 'relative',
        overflow: 'hidden',
        p: { xs: 2, md: 4 },
        pb: { xs: 4, md: 6 },
      }}
    >
      <Box sx={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <NeptuneScene />
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          width: { xs: '100%', sm: 340 },
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: 3,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
